import Base from '../config/Base';
import ep from '../../endPoints.constant';
class Upload extends Base {
    deleteAvatar() {
        const url = ep.upload.userAvatar();
        return this.apiClient.delete(url);
    }
}
export default Upload;
